import React from "react";
import { ImageProvider } from "../../../utils/image-provider";
import { Link } from "gatsby";
import '../home.css'

const ServiceHighlights = ({ data }) => {
  if (!data) return null;
  const { heading, heading_color, cards, watermark_1, watermark_2 } = data;

  return (
    <div className="relative w-full px-[5%] xl:px-[7%] flex flex-col items-center py-[3vh] z-[80] xl:py-[6vh] bg-white overflow-hidden">
      {/* Watermarks */}
      {watermark_1?.url && (
        <ImageProvider
          Image={watermark_1}
          alt={watermark_1.alternativeTextt || "Image"}
          fetchPriority="high"
          loading="eager"
          tailwindStyle={`pointer-events-none absolute left-[-20vw] xl:left-0 top-[20vw] xl:top-0 w-[60%] xl:w-[25vw]  h-auto opacity-80 z-0`}
        />
      )}
      {watermark_2?.url && (
        <ImageProvider
          Image={watermark_2}
          alt={watermark_2?.alternativeText || "Image"}
          fetchPriority="high"
          loading="eager"
          tailwindStyle={`pointer-events-none absolute right-[-10vw] xl:right-0 top-[120vw] xl:top-[4vw] w-[60%] xl:w-[25vw] h-auto opacity-80 z-0`}
        />
      )}

      {/* Heading */}
      <h2
        className="text-[4vh] xl:text-[6vh] font-bold mb-8 z-10 text-center"
        style={{ color: heading_color }}
      >
        {heading}
      </h2>

      {/* Cards */}
      <div className="flex flex-col xl:flex-row gap-[3vh] xl:gap-0 items-center justify-center w-full z-10">
        {cards?.length > 0 &&
          cards.map((card, idx) => {
            // Gradient color for overlay, fallback to card_bg_color
            const gr_color = card.card_bg_color || "#000000";
            return (
              <div
                key={idx}
                className="bg-transparent rounded-t-[30vh] overflow-hidden w-[80%] xl:w-[32.5%] h-[40vh] xl:h-[65vh] mx-auto relative service-card"
              >
                <Link
                  className="focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600 focus-visible:outline-offset-2 rounded-[2vh]"
                  to={
                    card?.heading === "Shop"
                      ? "/shop"
                      : card?.heading === "Dine"
                      ? "/eat-and-dine"
                      : card?.heading === "Travel Assistance"
                      ? "/greet-services"
                      : null
                  }
                >
                  {/* Background image as full card */}
                  <div
                    className="relative w-full h-full bg-cover bg-center"
                    style={{ backgroundImage: `url(${card.card_image?.url})` }}
                  >
                    {/* Gradient overlay */}
                    <div
                      className="absolute inset-0"
                      style={{
                        backgroundImage: `linear-gradient(to top, ${gr_color} 8%, rgba(0,0,0,0.1) 60%, transparent 70%)`,
                        opacity: 0.95,
                      }}
                    />
                    {/* Card content over the gradient */}
                    <div className="absolute bottom-0 w-full px-[4%] xl:px-[4%] pb-[3vh] xl:pb-[7vh] flex flex-col items-center text-center z-10 service-card-content">
                      <h3
                        className="text-[3.2vh] xl:text-[4.5vh] font-bold mb-[0.5vh] xl:mb-[1vh] service-card-title"
                        style={{ color: card.heading_color }}
                      >
                        {card?.heading?.toUpperCase()}
                      </h3>
                      <p className="text-white text-[2.5vh] line-spacing-0 xl:text-[3vh] font-normal drop-shadow-md service-card-desc">
                        {card.description?.data?.description}
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ServiceHighlights;
